import { render, staticRenderFns } from "./testdetail.vue?vue&type=template&id=03a1a6a2&scoped=true"
import script from "./testdetail.vue?vue&type=script&lang=js"
export * from "./testdetail.vue?vue&type=script&lang=js"
import style0 from "./testdetail.vue?vue&type=style&index=0&id=03a1a6a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a1a6a2",
  null
  
)

export default component.exports